import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#dc143c',
      light: '#e4465e',
      dark: '#b01030',
    },
    secondary: {
      main: '#3a3532',
      light: '#524d4a',
      dark: '#2a2724',
    },
    background: {
      default: '#ffffff',
      paper: 'rgba(255, 255, 255, 0.8)',
      glass: 'rgba(255, 255, 255, 0.7)',
    },
    text: {
      primary: '#3a3532',
      secondary: 'rgba(58, 53, 50, 0.7)',
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: {
      color: '#3a3532',
    },
    h2: {
      color: '#3a3532',
    },
    h3: {
      color: '#3a3532',
    },
    h4: {
      color: '#3a3532',
    },
    h5: {
      color: '#3a3532',
    },
    h6: {
      color: '#3a3532',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: 16,
          border: '1px solid rgba(220, 20, 60, 0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: 16,
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: 16,
          border: '1px solid rgba(220, 20, 60, 0.1)',
          boxShadow: '0 8px 32px 0 rgba(220, 20, 60, 0.1)',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(220, 20, 60, 0.05)',
          '& .MuiTableCell-head': {
            color: '#dc143c',
            fontWeight: 600,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(220, 20, 60, 0.04)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
        contained: {
          boxShadow: '0 4px 12px rgba(220, 20, 60, 0.2)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(220, 20, 60, 0.3)',
          },
        },
        outlined: {
          borderColor: '#dc143c',
          '&:hover': {
            borderColor: '#dc143c',
            backgroundColor: 'rgba(220, 20, 60, 0.04)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#dc143c',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#dc143c',
            },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(220, 20, 60, 0.04)',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 16,
  },
  shadows: [
    'none',
    '0 2px 4px rgba(220, 20, 60, 0.05)',
    '0 4px 8px rgba(220, 20, 60, 0.05)',
    '0 8px 16px rgba(220, 20, 60, 0.05)',
    '0 12px 24px rgba(220, 20, 60, 0.05)',
    '0 16px 32px rgba(220, 20, 60, 0.05)',
    ...Array(19).fill('none'),
  ],
});

export default theme;
